"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "addCustomRUMError", {
  enumerable: true,
  get: function get() {
    return _rum.addCustomRUMError;
  }
});
Object.defineProperty(exports, "addCustomRUMEvent", {
  enumerable: true,
  get: function get() {
    return _rum.addCustomRUMEvent;
  }
});
Object.defineProperty(exports, "initializeRealUserMonitoring", {
  enumerable: true,
  get: function get() {
    return _rum.initializeRealUserMonitoring;
  }
});
Object.defineProperty(exports, "setUser", {
  enumerable: true,
  get: function get() {
    return _rum.setUser;
  }
});

var _rum = require("./rum");
//# sourceMappingURL=index.js.map